import http from '@/http';

export default {
  namespaced: true,

  state: {
    profile: null,
  },
  getters: {
    isPremium(state) {
      return !!(state.profile && state.profile.premium);
    },
  },
  mutations: {
    setProfile(state, { profile }) {
      state.profile = profile;
    },
  },
  actions: {
    async getProfileData({ commit }) {
      const { data } = await http.request({
        url: '/neuralike-user/me/',
      });
      commit('setProfile', {
        profile: {
          firstName: data.first_name,
          lastName: data.last_name,
          birthDate: data.birth_date,
          sex: data.sex,
          image: data.image,
          premium: data.premium,
        },
      });
    },
    async setProfileData({ commit }, profile) {
      const formData = new FormData();

      if (profile.firstName) {
        formData.append('first_name', profile.firstName);
      }
      if (profile.lastName) {
        formData.append('last_name', profile.lastName);
      }
      if (profile.birthDate) {
        formData.append('birth_date', profile.birthDate);
      }
      if (profile.sex) {
        formData.append('sex', profile.sex);
      }
      if (profile.image) {
        formData.append('image', profile.image);
      }

      const { data } = await http.request({
        url: '/neuralike-user/me/',
        method: 'patch',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      commit('setProfile', {
        profile: {
          firstName: data.first_name,
          lastName: data.last_name,
          birthDate: data.birth_date,
          sex: data.sex,
          image: data.image,
        },
      });
    },
  },
};
